import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';
import { LettingAdvertismentPlatformType } from '../../model/const/enums';
import { LettingAdvertisment } from '../../model/letting-advertisment';
import { LettingAdvertismentService } from '../../service/letting-advertisment.service';

@Component({
    selector: 'letting-unpublished-warning',
    styleUrls: ['letting-unpublished-warning.component.scss'],
    template: `
    @if (list?.length) {
      <section class="astral-section-surface astral-section-surface--subtle astral-stack-s">
        <app-information-block text="LETTING.ADVERTISMENT.HAS_UNPUBLISHED" status="warning"></app-information-block>
        <div class="astral-stack-s">
          @for (item of list; track item) {
            <div>
              <a [routerLink]="['../edit', item.id]">
                @switch (item.platform) {
                  @case (lettingAdvertismentPlatformType.DhMarket) {
                    <span>{{
                      'LETTING.ADVERTISMENT.PLATFORMS.DHMARKET' | translate
                    }}</span>
                  }
                  @case (lettingAdvertismentPlatformType.HomeQ) {
                    <span>{{ 'LETTING.ADVERTISMENT.PLATFORMS.HOMEQ' | translate }}</span>
                  }
                }
              </a>
            </div>
          }
        </div>
      </section>
    }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LettingUnpublishedWarningComponent implements OnInit, OnDestroy {
  @Input({ required: true }) readonly rentalObjectId: string;

  protected lettingAdvertismentPlatformType = LettingAdvertismentPlatformType;
  protected list: LettingAdvertisment[];

  private destroy = new Subject<void>();

  constructor(
    private readonly _userAccountService: UserAccountService,
    private readonly _lettingAdvertismentService: LettingAdvertismentService
  ) {}

  ngOnInit(): void {
    combineLatest([this._userAccountService.current, this._lettingAdvertismentService.getRentalObjectAdvertisments(this.rentalObjectId)])
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: ([account, advertisments]) => {
          this.list = [];

          if (account.hasAccess(ModuleNames.Letting, Features.Letting_DhMarket)) {
            const unpublished = advertisments
              .filter(x => !x.sentToPlatformAt && x.platform === LettingAdvertismentPlatformType.DhMarket)
              .find(Boolean);
            if (unpublished) {
              this.list.push(unpublished);
            }
          }

          if (account.hasAccess(ModuleNames.Letting, Features.Letting_HomeQ)) {
            const unpublished = advertisments
              .filter(x => !x.sentToPlatformAt && x.platform === LettingAdvertismentPlatformType.HomeQ)
              .find(Boolean);
            if (unpublished) {
              this.list.push(unpublished);
            }
          }
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
  }
}
